import { config } from '@/core/config'

export default {
  install: (app) => {
    app.config.globalProperties.$config = config
  },
}
